import axios from 'axios';
import { ShortInfo, ListViewData, VehiclesInfo } from '@/types/api';

export async function getIncludedOptions (apiUrl: string, vehicleId: number): Promise<string> {
    const formData = new FormData();
    formData.append('id', vehicleId.toString());
    return axios
        .post(apiUrl + '?action=get-included-options', formData, {
            headers: { 'content-type': 'application/x-www-form-urlencoded' }
        })
        .then(response => response.data);
}

export async function getVehiclesInfo (apiUrl: string, ids: number[]): Promise<VehiclesInfo> {
    const formData = new FormData();
    formData.append('ids', ids.join(','));
    return axios
        .post(apiUrl + '?action=info', formData, {
            headers: { 'content-type': 'application/x-www-form-urlencoded' }
        })
        .then(response => response.data as VehiclesInfo);
}

export async function getVehiclesShortInfo (apiUrl: string, ids: number[]): Promise<ShortInfo> {
    const formData = new FormData();
    formData.append('ids', ids.join(','));
    return axios
        .post(apiUrl + '?action=get-short-info', formData, {
            headers: { 'content-type': 'application/x-www-form-urlencoded' }
        })
        .then(response => response.data);
}

export async function getVehiclesHtml (
    apiUrl: string, ids: number[], itemsPerPage: number, offset: number
): Promise<ListViewData> {
    const formData = new FormData();
    formData.append('ids', ids.join(','));
    formData.append('limit', itemsPerPage.toString());
    formData.append('offset', offset.toString());
    return axios
        .post(apiUrl + '?action=view', formData, {
            headers: { 'content-type': 'application/x-www-form-urlencoded' }
        })
        .then((response) => {
            return response.data || { items: [], liveIds: [] };
        });
}

export async function removeFromShortlist (apiUrl: string, id: number): Promise<boolean> {
    const formData = new FormData();
    formData.append('id', id.toString());
    return updateStateOnBackend(apiUrl + '?action=remove', formData);
}

export async function setIsDisplayingDifference (apiUrl: string, isDisplaying: boolean): Promise<boolean> {
    const formData = new FormData();
    formData.append('isDisplaying', (+isDisplaying).toString());
    return updateStateOnBackend(apiUrl + '?action=set-displaying-diff', formData);
}

export async function setIsSellerOpened (apiUrl: string, isOpened: boolean): Promise<boolean> {
    const formData = new FormData();
    formData.append('isOpened', (+isOpened).toString());
    return updateStateOnBackend(apiUrl + '?action=set-seller-menu', formData);
}

export async function setIsTechOpened (apiUrl: string, isOpened: boolean): Promise<boolean> {
    const formData = new FormData();
    formData.append('isOpened', (+isOpened).toString());
    return updateStateOnBackend(apiUrl + '?action=set-tech-menu', formData);
}

export async function setIsComparing (apiUrl: string, isComparing: boolean): Promise<boolean> {
    const formData = new FormData();
    formData.append('isComparing', (+isComparing).toString());
    return updateStateOnBackend(apiUrl + '?action=set-is-comparing', formData);
}

export async function setComparingItems (apiUrl: string, items: number[]): Promise<boolean> {
    const formData = new FormData();
    formData.append('items', items.join(','));
    return updateStateOnBackend(apiUrl + '?action=set-comparing-items', formData);
}

async function updateStateOnBackend (url: string, data: FormData): Promise<boolean> {
    return await axios
        .post(url, data, {
            headers: { 'content-type': 'application/x-www-form-urlencoded' }
        })
        .then((response) => {
            return response.status === 200;
        });
}
